module.exports = __webpack_public_path__ + "img/Golf Clubs.f4ff0973.png";